import ChartContainer from "../../../../Components/General/Widgets/Chart/ChartContainer";

const Chart = () => {
  return <ChartContainer />;
};

export default Chart;
